<section class="product-shipping-section">
  <div class="container-title">
    {{ 'text_shippingInformation' | dbText }}
  </div>
  <div class="shipping-form"
       [formGroup]="shippingForm">
    <div class="row">
      <div class="field-wrapper" *ngIf="isEdit">
        <div class="field-label">
          {{ 'text_shippingClass' | dbText }}
        </div>
        <ds-dropdown (onFullOptionChoose)="onShippingChange($event)"
                     [dsDropdownSmallFont]="true"
                     [dsDropdownPlaceholderStyle]="true"
                     [dsDropdownPlaceHolder]="!!shippingClassesDropdown?.length ? ('text_chooseShippingClass' | dbText) : ('text_noShippingClassAvailable' | dbText)"
                     [value]="shippingClassFormControl.valueChanges|async"
                     [dsDropdownOptions]="shippingClassesDropdown">
        </ds-dropdown>
      </div>
      <div class="field-wrapper" *ngIf="!isEdit">
        <div class="field-label">
          {{ 'text_height' | dbText }}
        </div>
        <input class="ds-input"
               type="text"
               appCurrencyMask
               [placeholder]="'Ex. 5.34 ' + measurements.dimension_unit"
               [otherMeasurement]="measurements.dimension_unit"
               placeholder="0.00"
               formControlName="height">
      </div>
      <div class="field-wrapper">
        <div class="field-label">
          {{ 'text_weight' | dbText }}
        </div>
        <input class="ds-input"
               type="text"
               appCurrencyMask
               [placeholder]="'Ex. 20.00 ' + measurements.weight_unit"
               [otherMeasurement]="measurements.weight_unit"
               formControlName="weight">
      </div>
    </div>
    <div class="row">
      <div class="field-wrapper">
        <div class="field-label">
          {{ 'text_length' | dbText }}
        </div>
        <input class="ds-input"
               type="text"
               appCurrencyMask
               [placeholder]="'Ex. 10.00 ' + measurements.dimension_unit"
               [otherMeasurement]="measurements.dimension_unit"
               placeholder="0.00"
               formControlName="length">
      </div>
      <div class="field-wrapper">
        <div class="field-label">
          {{ 'text_width' | dbText }}
        </div>
        <input class="ds-input"
               type="text"
               appCurrencyMask
               [placeholder]="'Ex. 30.09 ' + measurements.dimension_unit"
               [otherMeasurement]="measurements.dimension_unit"
               placeholder="0.00"
               formControlName="width">
      </div>
      <div class="field-wrapper" *ngIf="isEdit">
        <div class="field-label">
          {{ 'text_height' | dbText }}
        </div>
        <input class="ds-input"
               type="text"
               appCurrencyMask
               [placeholder]="'Ex. 5.34 ' + measurements.dimension_unit"
               [otherMeasurement]="measurements.dimension_unit"
               placeholder="0.00"
               formControlName="height">
      </div>
    </div>
  </div>
</section>
